export class ProviderService {
    private static instance: ProviderService

    public providerMap: Array<ProviderMapPair> = []

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): ProviderService {
        if (!this.instance) {
            this.instance = new ProviderService()
        }
        return this.instance
    }

    /**
     * retourne le Service qui correspond à la clef donnée
     * @param key Clef du pointeur de fonction à récupèrer
     */
    public get(key: string): any {
        const providerMapPair: ProviderMapPair | undefined =
            this.providerMap.find((pair: ProviderMapPair) => {
                return key === pair.key
            })

        return providerMapPair?.service
    }

    /**
     * ajoute un entrée dans le tableau de mapping
     * @param pair Paire à modifier / ajouter
     */
    public set(pair: ProviderMapPair): void {
        // on récupère l'index du tableau de la cléf donnée en paramètre
        const providerMapPairIndex: number = this.providerMap.findIndex(
            (currentPair: ProviderMapPair) => {
                return pair.key === currentPair.key
            }
        )

        // si une clef de ce nom existe déjà on met à jour sinon on push la nouvelle valeur
        if (providerMapPairIndex > -1) {
            this.providerMap[providerMapPairIndex] = pair
        } else {
            this.providerMap.push(pair)
        }
    }
}

export interface ProviderMapPair {
    key: string
    service: any
}
